module.exports = __webpack_public_path__ + "static/media/pasteColumn.352e7ae3.svg";